import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'FileIcon',
  props: {
    fileName: {}
  },
  setup(__props: any) {

const props = __props

const isImage = computed(() => {
  return props.fileName.match(/\.(jpg|jpeg|gif)$/i)
})

const isPng = computed(() => {
  return props.fileName.match(/\.(png)$/i)
})

const isZip = computed(() => {
  return props.fileName.match(/\.(zip)$/i)
})

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!

  return (isPng.value)
    ? (_openBlock(), _createBlock(_component_v_img, {
        key: 0,
        width: 40,
        height: 40,
        src: '/images/fileicon/png.png'
      }))
    : (isImage.value)
      ? (_openBlock(), _createBlock(_component_v_img, {
          key: 1,
          width: 40,
          height: 40,
          src: '/images/fileicon/image.png'
        }))
      : (isZip.value)
        ? (_openBlock(), _createBlock(_component_v_img, {
            key: 2,
            width: 40,
            height: 40,
            src: '/images/fileicon/zip.png'
          }))
        : (_openBlock(), _createBlock(_component_v_img, {
            key: 3,
            width: 40,
            height: 40,
            src: '/images/fileicon/documents.png'
          }))
}
}

})